document.querySelectorAll('.mega-menu__link--top').forEach(link => {

  if (link.getAttribute('href') === '#') {
    link.setAttribute('href', 'javascript:void(0);');
  }

  // 2️⃣ Italicize text AFTER "Shop By"
  const text = link.textContent.trim();

  if (text.startsWith('Shop By')) {
    const restText = text.replace(/^Shop By\s*/i, '');

    // Prevent double-processing
    if (!link.querySelector('i')) {
      link.innerHTML = `Shop By <i>${restText}</i>`;
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
    const toggleBtn = document.querySelector('.citogglefilter');
    const filterList = document.querySelector('.ciflterlist');

    if (!toggleBtn || !filterList) return;

    toggleBtn.addEventListener('click', () => {
      filterList.classList.toggle('active');
    });
  });


document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".trade-block .btn--primary");
  const target = document.querySelector(".trade-inquiry-form");
  const offset = 80;

  if (button && target) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    });
  }
  
  const containers = document.querySelectorAll('.openewtab');

  if (containers.length) {
    containers.forEach(container => {
      const links = container.querySelectorAll('a');

      if (links.length) {
        links.forEach(link => {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        });
      }
    });
  }


});
